import { styled } from '@mui/material/styles';

export const SceneImage = styled('img')(({ theme }) => ({
  marginBottom: theme.spacing(3),
  maxHeight: '180px',
  maxWidth: '180px',
  width: '80%',
}));
